<template>
    <div class="mt-15">
        <v-tabs
            v-model="tab"
            class="mt-3 c-transparent-tabs"
            align-tabs="center"
            center-active
        >
            <v-tab
                v-for="(tab, index) in tabs"
                :value="index"
                :key="index"
                color="cis-accent-color"
                class="font-weight-normal"
            >
                {{ tab.name }}
            </v-tab>
        </v-tabs>
        <v-sheet class="border">
            <v-card-text>
                <v-window v-model="tab">
                    <v-window-item v-for="(tab, index) in tabs"
                                   :value="index"
                                   :key="index"
                    >
                        <template v-if="'content' in tab">
                            <div v-html="tab.content"/>
                            <template v-if="tab.params && tab.params.length > 0">
                                <v-sheet class="border" :class="{'mt-4': tab.content}">
                                    <v-table density="compact" class="text-caption flex-grow-1">
                                        <tbody>
                                        <tr v-for="(parameter, index) in tab.params" :key="index">
                                            <th>{{ parameter.title }}{{
                                                    parameter.unit ? ` [${parameter.unit}]` : ''
                                                }}:
                                            </th>
                                            <td>
                                                <template v-if="parameter.values">
                                                    <template v-for="(value, index) in parameter.values" :key="index">
                                                        <a v-if="value.link" :href="value.link"
                                                           class="text-cis-accent-color" target="_blank" v-html="value.value">
                                                        </a>
                                                        <span v-else v-html="value.value">
                                                            </span>
                                                        <template v-if="index + 1 !== parameter.values.length">
                                                            <span>, </span>
                                                        </template>
                                                    </template>
                                                </template>
                                                <span v-else v-html="parameter.value"></span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </v-table>
                                </v-sheet>
                            </template>
                        </template>
                        <template v-else-if="'component' in tab">
                            <component :is="tab.component" v-bind="tab.props"></component>
                        </template>
                        <template v-else>
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ab, culpa, id. Ab animi,
                            blanditiis doloremque eius esse eveniet excepturi expedita explicabo incidunt laborum magnam
                            nostrum odit porro quisquam vitae voluptas!
                        </template>
                    </v-window-item>
                </v-window>
            </v-card-text>
        </v-sheet>
        <also-like v-if="$page.props.also_like.length"/>
    </div>
</template>

<script setup>
import {computed, defineAsyncComponent, ref} from 'vue';
import AlsoLike from "./AlsoLike.vue";
import {usePage} from "@inertiajs/vue3";
import {trans} from 'laravel-vue-i18n';

const props = defineProps({
    product: Object
})

const tab = ref(null);
const tabs = computed(() => {
    const _tabs = [];
    if (props.product.description || props.product.product_parameters) {
        _tabs.push({
            name: trans('eshop::product-details.description'),
            content: props.product.description,
            params: formatParams(props.product.product_parameters)
        })
    }
    /*_tabs.push({
        name: trans('eshop::product-details.reviews'),
        component: defineAsyncComponent(() => import('./Reviews.vue')),
        props: {
            user: usePage().props.customer,
            count: props.product.product_reviews_count,
            id_product: props.product.id,
        },
    })*/
    if(props.product.video_id){
        _tabs.push({
            name: trans('eshop::product-details.video'),
            component: defineAsyncComponent(() => import('./YoutubeVideo.vue')),
            props: {
                videoId: props.product.video_id,
            }
        })
    }

    return _tabs;
});

const filterVariant = (param, paramValues) => {
    const option = props.product.variants.options.find(item => item.id_parameters === param.parameter.id);
    if (option) {
        const value = paramValues.find(item => item.id === option.id_products_parameters_values);
        if (value) {
            return [value]
        }
    }
    return paramValues;
}

const formatParams = (params) => {
    const paramsComputed = [];
    if (params) {
        params.forEach((param) => {
            if (param.parameter.type === 'text') {
                let values = [];
                let paramValues = param.products_parameters_values;
                if(props.product.is_variant){
                    paramValues = filterVariant(param, paramValues) || paramValues;
                }

                if (paramValues.length) {
                    values = paramValues.map((val) => {
                        const obj = {};
                        if (val.value || val.value === 0) {
                            if (param.parameter.show_as === 'colors') {
                                obj.value = `<span class="color-dot" style="background-color: ${val.parameters_values.show_as}"></span>`
                            } else {
                                obj.value = val.parameters_values?.show_as || val.parameters_values?.name || val.value
                            }
                            return obj
                        }
                        if (props.product.default_group?.id && param.parameter.use_in_filter) {
                            obj.link = `${props.product.default_group.url}/${param.parameter.slug}_${val.parameters_values.slug}`
                        }
                        if (param.parameter.show_as === 'colors') {
                            obj.value = `<span class="color-dot" style="background-color: ${val.parameters_values.show_as}"></span>`
                        } else {
                            obj.value = val.parameters_values.show_as || val.parameters_values.name
                        }
                        return obj
                    });
                }

                if (values.length) {
                    paramsComputed.push({
                        title: param.parameter.name,
                        unit: param.parameter.unit,
                        show_as: param.parameter.show_as,
                        values,
                    });
                }
            } else {
                let values = [];
                let paramValues = param.products_parameters_values;
                if(props.product.is_variant){
                    paramValues = filterVariant(param, paramValues) || paramValues;
                }

                if (paramValues.length) {
                    values = paramValues.map((val) => val.parameters_values?.show_as || val.parameters_values?.name || val.value);
                    if (values.length) {
                        paramsComputed.push({
                            title: param.parameter.name,
                            unit: param.parameter.unit,
                            show_as: param.parameter.show_as,
                            value: values.join(', '),
                        });
                    }
                }
            }
        });
    }
    return paramsComputed;
}
</script>

<style scoped lang="scss">
:deep(.color-dot) {
    display: inline-block;
    width: 1.2em;
    height: 1.2em;
    border-radius: 50%;
    box-shadow: 0 0 .7em grey;
}
</style>
